import React from "react";
import ActiveBadge from "../../../components/ActiveBadge";
import Chip from "../../../components/Chip";
import LifecycleBadge from "../../../components/LifecycleBadge";
import { extraPayload } from "../features/domain-event.utils";

// Columns of the Domain Event list. `start` is the row number offset of the current page.
export const getDomainEventColumns = (start) => [
  {
    key: "id",
    label: "S.No",
    width: "70px",
    sortable: false,
    render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span>,
  },
  {
    key: "name",
    label: "Event",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-medium text-text_primary">{row.name || "—"}</span>
        <span className="truncate font-mono text-[11px] text-text_muted">{row.event_key}</span>
      </div>
    ),
  },
  {
    key: "source_fid",
    label: "Source",
    sortable: true,
    render: (row) =>
      row.source ? (
        <div className="flex min-w-0 items-center gap-2">
          <span className="truncate text-xs text-text_primary">{row.source.label}</span>
          <LifecycleBadge status={row.source.status} />
        </div>
      ) : (
        <span className="text-xs text-text_muted">—</span>
      ),
  },
  {
    key: "payload_schema",
    label: "Extra Keys",
    sortable: false,
    render: (row) => {
      const extra = extraPayload(row.payload_schema);
      return extra.length ? (
        <div className="flex flex-wrap gap-1">
          {extra.slice(0, 3).map((item) => (
            <Chip key={item.key} className="font-mono">
              {item.key}
            </Chip>
          ))}
          {extra.length > 3 && <Chip>+{extra.length - 3}</Chip>}
        </div>
      ) : (
        <span className="text-xs text-text_muted">—</span>
      );
    },
  },
  {
    key: "trigger_count",
    label: "Triggers",
    sortable: false,
    render: (row) => <Chip>{row.trigger_count ?? 0} triggers</Chip>,
  },
  {
    key: "sort_order",
    label: "Order",
    sortable: true,
    render: (row) => <span className="text-xs text-text_secondary">{row.sort_order ?? 0}</span>,
  },
  {
    key: "is_activated",
    label: "Status",
    sortable: true,
    render: (row) => <ActiveBadge active={row.is_activated} />,
  },
];
